import { DexFormsResponse, OriAliasOptionDto } from '@mark43/cad-api';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { useSelectedOriAlias } from './use-selected-ori-alias';
import { useOriAliases } from '../../common/hooks/use-ori-aliases';

type UseDexFormView = {
    dexFormsResponse?: DexFormsResponse;
    oriAliasOptions?: OriAliasOptionDto[];
};
export const useDexFormView = ({ dexFormsResponse }: UseDexFormView) => {
    const { multipleOriEnabled } = useEnabledFeatures();
    const { selectedOriAliasId } = useSelectedOriAlias();
    const oriAliasOptions = useOriAliases();

    if (!dexFormsResponse) {
        return undefined;
    }

    if (!multipleOriEnabled) {
        return dexFormsResponse;
    }

    if (multipleOriEnabled && !oriAliasOptions) {
        return undefined;
    }

    const oriAliasValueToUse = selectedOriAliasId
        ? oriAliasOptions.find((oriAliasOption) => `${oriAliasOption.value}` === selectedOriAliasId)
              ?.label
        : oriAliasOptions.find((oriAliasOption) => oriAliasOption.isDefault)?.label;

    return oriAliasValueToUse
        ? dexFormsResponse?.['dexFormsByOriAlias']?.[oriAliasValueToUse]
        : undefined;
};
